import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

export default styled("div")(({ theme, ownerState }) => {

  const userTheme = useSelector((state) => state.commonSlice.theme);
  const { palette, functions, borders } = theme;
  const { error, success, disabled } = ownerState;

  const { inputColors, grey, white, common } = palette;
  const { pxToRem } = functions;
  const { borderRadius, borderWidth } = borders;

  // border color value
  let borderColorValue = inputColors.borderColor.main;

  if (error) {
    borderColorValue = inputColors.error;
  } else if (success) {
    borderColorValue = inputColors.success;
  }

  return {
    display: "flex",
    alignItems: "center",
    // backgroundColor: 'rgb(23 23 23 / 84%) !important', 
    backdropFilter: "blur(10px)", // blur effect for glassmorphism
    // border: `${borderWidth[1]} solid`,
    borderRadius: borderRadius.md,
    // borderColor: borderColorValue,
    border: '1px solid rgba(255, 255, 255, 0.14) !important',
    boxShadow: `0 4px 6px rgba(0, 0, 0, 0.1)`, 
    // Optional: adding some padding for spacing inside the component

    // When not disabled, we use a transparent background with a slight frosted look
    "& .MuiInputBase-input": {
      height: pxToRem(20),
      color: userTheme=='dark'? common.white :'#141414', // optional: for better readability on the frosted background
    },
  };
});
